import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { MessageCircle, Instagram } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Coaching = () => {
  const [siteConfig, setSiteConfig] = useState(null);

  useEffect(() => {
    fetchSiteConfig();
  }, []);

  const fetchSiteConfig = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/site-config`);
      setSiteConfig(response.data);
    } catch (error) {
      console.error('Error fetching site config:', error);
    }
  };

  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('/api')) return `${BACKEND_URL}${url}`;
    return url;
  };

  const coaches = [
    { 
      name: 'Deisy Fit', 
      instagram: '@deisyfit',
      instagramUrl: 'https://instagram.com/deisyfit',
      imageKey: 'coaching_image_deisy',
      fallbackKey: 'about_image_deisy',
      defaultImage: 'https://images.unsplash.com/photo-1683848644078-f339179c4ff6?crop=entropy&cs=srgb&fm=jpg&q=85',
      whatsapp: 'https://wa.link/vcq8di'
    },
    { 
      name: 'Karen Marino', 
      instagram: '@karenmarinob',
      instagramUrl: 'https://instagram.com/karenmarinob',
      imageKey: 'coaching_image_karen',
      fallbackKey: 'about_image_karen',
      defaultImage: 'https://images.unsplash.com/photo-1669502299593-5dbb23edfdb4?crop=entropy&cs=srgb&fm=jpg&q=85',
      whatsapp: 'https://wa.link/hlvj64'
    }
  ];

  return (
    <div className="min-h-screen bg-[#09090b] py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-pink-500 text-sm font-bold uppercase tracking-[0.2em]">Entrenamiento Personalizado</span>
          <h1 className="font-barlow text-4xl md:text-6xl font-bold text-white mt-4" data-testid="coaching-title">
            COACHING <span className="text-pink-500">1:1</span>
          </h1>
          <p className="text-lg text-zinc-400 mt-4 max-w-2xl mx-auto">
            Entrenamiento personalizado con nuestras entrenadoras expertas
          </p>
        </div>

        {/* Coaches Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {coaches.map((coach) => {
            // Usar imagen de coaching, si no existe usar la de about, si no la default
            const imageUrl = siteConfig?.[coach.imageKey] 
              ? getImageUrl(siteConfig[coach.imageKey])
              : siteConfig?.[coach.fallbackKey]
                ? getImageUrl(siteConfig[coach.fallbackKey])
                : coach.defaultImage;
            
            return (
              <div 
                key={coach.name} 
                className="bg-zinc-900 border border-zinc-800 rounded-3xl overflow-hidden hover:border-pink-500/50 transition-all duration-300 flex flex-col"
                data-testid={`coach-${coach.name.toLowerCase().replace(' ', '-')}`}
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img 
                    src={imageUrl} 
                    alt={coach.name} 
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-zinc-900 to-transparent" />
                </div>
                <div className="p-8">
                  <h3 className="font-barlow text-2xl font-bold text-white mb-2">{coach.name}</h3>
                  <a 
                    href={coach.instagramUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-pink-500 hover:text-pink-400 transition-colors mb-6"
                  >
                    <Instagram className="w-4 h-4" />
                    {coach.instagram}
                  </a>
                  <div className="mt-4">
                    <a href={coach.whatsapp} target="_blank" rel="noopener noreferrer">
                      <Button className="w-full bg-pink-600 hover:bg-pink-500 text-white rounded-full py-6 font-bold glow-pink">
                        <MessageCircle className="w-5 h-5 mr-2" />
                        Solicitar Coaching
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Coaching;
